import { ButtonApiErrorWrapper } from 'app/components/shared/ButtonApiErrorWrapper'
import { SmartFileInput } from 'app/components/shared/FormComponents/SmartFileInput'
import { UploadFileSection } from 'app/components/shared/UploadFileSection'
import { Button } from 'app/components/ui/Button'
import { Container } from 'app/components/ui/Container'
import { Form } from 'app/components/ui/Form'
import { Text } from 'app/components/ui/Text'
import { useUploadFileUser } from 'app/queries/user'
import { theme } from 'app/styles/themeEstra'
import { pdfInputTypes } from 'app/utils/fileUtils'
import React from 'react'
import styled from 'styled-components'

import {
  adaptFormDataToAPI,
  inputRegistryDefaultValues,
  InputRegistryDocumentFormData,
  inputRegistryValidationSchema,
} from './form'

type Props = {
  onRegistrationCompleted: () => void
}
export const InputRegistryDocumentForm = ({
  onRegistrationCompleted,
}: Props): JSX.Element => {
  const { mutate: uploadFile, isLoading, isError, error } = useUploadFileUser()

  const onSubmit = (data: InputRegistryDocumentFormData) =>
    uploadFile(adaptFormDataToAPI(data), {
      onSuccess: () => {
        onRegistrationCompleted()
      },
    })

  return (
    <FileUploadedContainer>
      <UploadFileSection title={`Carica il file di anagrafica firmato`}>
        <Form<InputRegistryDocumentFormData>
          defaultValues={inputRegistryDefaultValues}
          validationSchema={inputRegistryValidationSchema}
          onSubmit={onSubmit}
        >
          <FileInputGroup>
            <Text variant='s14' color={theme.color.primari.grigioEstra} mb={2}>
              Attenzione: quando scansioni e ricarichi il PDF firmato, accertati
              che sia il documento completo, contenente sia tutte le pagine
              della scheda anagrafica che la scansione del documento
              d&apos;identità del titolare come ultima pagina.
            </Text>
            <SmartFileInput
              name='input_registry'
              accept={pdfInputTypes.join(', ')}
              description='Formato immagine o PDF, dimensione massima 10 MB'
            ></SmartFileInput>
          </FileInputGroup>
          <ButtonApiErrorWrapper isError={isError} error={error} alignCenter>
            <Button type='submit' size='lg' disabled={isLoading}>
              {isLoading ? 'Caricamento...' : 'SALVA'}
            </Button>
          </ButtonApiErrorWrapper>
        </Form>
      </UploadFileSection>
    </FileUploadedContainer>
  )
}

const FileUploadedContainer = styled(Container)`
  text-align: center;
`

const FileInputGroup = styled.div`
  margin-bottom: 2rem;

  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`
